import React, { Component } from 'react';
import SurveyRect from './Shared/SurveyRect';
import FormatText from '../Utils/TextFormatter';
import ScaleQuestionItem from './Shared/ScaleQuestionItem';
import Button from './Shared/Button';
import Animator from '../Animator';
import shuffleAnswers from '../Utils/ShuffleAnswers';


export default class ScaleQuestionPage extends Component {

    state = {       
        compUniqueId: "",
        // ansInx:-1,
        key:"",
        items: [],
        answers: {}, 
        isValid: false,
    }

    componentDidMount(){
        let {items, randomizeOrder} = this.props;

        let _answers ={};

        for(let i=0; i<items.length; i++)
        {
            let ans = {};
            ans[items[i].key] = -1;
            _answers[i] = ans;
        }

        if(randomizeOrder) {items = shuffleAnswers(items);}
        
        this.setState({key: this.props.qKey, items: items, answers: _answers});
    }

    itemAnswerSelected = (itemIndex, itemKey, ansIndex)=>{
        let answer = {};
        
        if(!this.props.customizeValues) {
            ansIndex ++;
            answer[itemKey] = ansIndex;
        } else {
            answer[itemKey] = this.props.values[ansIndex];
        }

        let _answers = Object.assign({}, this.state.answers);
        _answers[itemIndex] = answer;

        this.setState({answers: _answers}, this.validatePage );
        
       
        
    }

    scrollToItem = (itemKey) => {
        const item = document.getElementById(itemKey);
        const targetPos = item.offsetTop - 60;
        const scrollDiv = document.getElementById(`scale_items_container_${this.state.key}`);
        const initPos = scrollDiv.scrollTop;
        const delta = targetPos - initPos;
       

        // if(scrollDiv.scrollHeight - targetPos - 20 < scrollDiv.clientHeight) return;

        Animator.animate({
            duration: 400, 
            timing: Animator.Ease.easeOutQuad,
            draw(progress) {
                const pos = initPos + delta * progress;
                scrollDiv.scrollTop = pos;
            }
        })
    }

    validatePage = () =>{
        const answers = this.state.answers;
        let itemKey = "";
        let foundNext = false;
        Object.keys(answers).forEach((key,index)=>{   
            // const value = Object.values(answers[key])[0];        
            const value = answers[key][Object.keys(answers[key])[0]]; //works on Internet Explorer

            if(!foundNext && value === -1) {
                itemKey = this.props.items[index].key;
                foundNext = true;
            }
        });
        if(!foundNext) {
            this.setState({isValid: true});
            return;
        }

        if(this.props.items.length < 3) return;
        setTimeout(()=>{this.scrollToItem(itemKey)}, global.isMobile? 200 : 0);
    }

    render(){
        const {style, question, description, qTextSize, items, scaleSize, altButtonTitle, values, customizeValues} = this.props;
        const padding = 28;

        let questionText;
        if(qTextSize === `small`){ 
            questionText = <div className="smallQuestion">{FormatText(global.isMale,question)}</div>
        }
        if(qTextSize === `medium`){ 
            questionText = <h3>{FormatText(global.isMale,question)}</h3>
        }
        if(qTextSize === `large`){ 
            questionText = <h2>{FormatText(global.isMale,question)}</h2>
        }

        // let _style = Object.assign({backgroundColor: 'red'},style);
        // console.log("_style: " + JSON.stringify(_style, null, 2));

        const buttonText = (altButtonTitle !== "" && altButtonTitle !== undefined) ? altButtonTitle : "המשך";

		return <div style={style}>
            <SurveyRect {...this.props} H={440} opacity={1}>
                <div style={{
                    position: "absolute",
                    right: padding,
                    left: padding,
                    top: padding,
                    bottom: 0,
                    textAlign: "right",
                }}>
                    <div id={`scale_items_container_${this.state.key}`} style={{
                        position: "absolute",
                        top: 0,
                        right: 0,
                        left: -padding,
                        bottom: 80, 
                        overflowY: "scroll"
                    }}>
                        <div  style={{marginLeft: 20}}>{questionText}</div>
                        <div style={{
                            // position: "-webkit-sticky",
                            position: "sticky",
                            top: 0,
                            marginLeft: 20,
                            background: "linear-gradient(to top, rgba(255,255,255,0) 0%,rgba(255,255,255,1) 20%)",
                            zIndex: 20,
                        }}>
                            
                            {(description !== ``) && <div style={{
                                maxHeight: 20,
                                whiteSpace: 'nowarp', 
                                overflow: 'hidden', 
                            }}>{FormatText(global.isMale,description)}</div>}
                            <span style={{fontSize:8, lineHeight: 4}}>▒▒▒▒▒▒▒▒▒▒▒▒</span>
                        </div>

                        {items.map((item,i)=> {
                            const _itemKey = item.key;
                            const _condition = FormatText(global.isMale,item.condition);
                            return <ScaleQuestionItem key={i} 
                                itemIndex={i} 
                                itemKey={_itemKey} 
                                padding={padding} 
                                condition={_condition} 
                                scaleSize={scaleSize}
                                values={values}
                                customizeValues={customizeValues}
                                onClick={this.itemAnswerSelected}
                            />
                        })}

                    </div>
                    <div id="bottom_fade" style={{
                        position:"absolute",
                        left: 0,
                        right: 0,
                        height: 20,
                        bottom:80,
                        zIndex: 40,
                        pointerEvents: "none",
                        background: "linear-gradient(to bottom, rgba(255,255,255,0) 0%,rgba(255,255,255,1) 100%)",
                    }}/>
                </div>
                <Button style={{
                    position:"absolute",
                    left:padding,
                    bottom:padding,
                }} text={buttonText} isActive={this.state.isValid} onClick={this.SetAnswer}/>
            </SurveyRect>
        </div>
    }

    SetAnswer = ()=>{       
        const answers = this.state.answers;
        // console.log(JSON.stringify(this.state.answers, null, 2));
        Object.keys(answers).forEach((k,index)=>{
            const itemKey = Object.keys(answers[k])[0];
            const value = answers[k][Object.keys(answers[k])[0]];
            let ansKey = this.props.qKey;
            if(itemKey !== "") {ansKey += "_" + itemKey;}

            global.setAnswer(ansKey, value);
        });
        
        global.nextStage(this.props.followingScreen);
    }
}


// WEBPACK FOOTER //
// ./src/Comp/ScaleQuestionPage.js